import { map } from 'rxjs/operators';
import { NewContactPage } from './../../new-contact/new-contact.page';
import { PlayerDetails } from './../../../../data/competition-teams';
import {
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  Platform,
  ToastController,
} from '@ionic/angular';
import {
  PlayerInfo,
  PlayerList,
  PlayerHomeInfo,
  createPlayerList,
  createPlayerInfo,
} from '../../../../data/player-data';
import { FriendService } from '../../../../providers/friend-service/friend-service';
import { NewGameInfo } from '../../../../data/game-round';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Component, Input, OnInit } from '@angular/core';
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { PlayerService } from '../../../../providers/player-service/player-service';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { AlertController } from '@ionic/angular';
import {
  TeeTimeBookingPlayer,
  PlayerData,
  ClubMembership,
  PlayerDiscountProgram,
  DiscountCompany,
  PlayerClubWalletBalancePage,
  ClubMembershipExtended,
  PlayerClubWalletBalance,
  PlayerClubAccount,
  ClubCustomer,
} from '../../../../data/mygolf.data';
import { PlayerHomeDataService } from '../../../../redux/player-home';
import { Observable } from 'rxjs';
// import { isTrueProperty } from '@ionic-angular/util/util';
import { ClubFlightService } from '../../../../providers/club-flight-service/club-flight-service';
import { JsonService } from '../../../../json-util';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Router } from '@angular/router';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

export interface NonMg2uPlayer {
  playerName: string;
  email: string;
  gender: string;
}
@Component({
  templateUrl: 'add-player-list.page.html',
  selector: 'add-player-list-page',
  styleUrls: ['./add-player-list.page.scss'],
  providers: [Keyboard],
})
export class AddPlayerListPage implements OnInit {
  listMode: string = 'friends';
  openedModal: boolean = false;
  playersToExclude: Array<TeeTimeBookingPlayer> = [];
  gameInfo: NewGameInfo;
  listFriends: PlayerList;

  friends: Array<PlayerInfo> = [];
  players: Array<any> = [];
  playerList: PlayerList;
  searchQuery: string = '';
  searchPlayers: string = '';

  availablePlayers: Array<PlayerInfo> = [];
  nonMg2uPlayer: NonMg2uPlayer;
  addPlayerForm: FormGroup;
  playerName: AbstractControl;
  email: AbstractControl;
  gender: AbstractControl;
  phone: AbstractControl;

  _playerName: string;
  _email: string;
  _gender: string = 'M';
  _phone: string;

  isCovid: boolean = true;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  currentPlayerId: number;
  _newPlayer: PlayerInfo;
  fromClub: boolean;
  infiniteComplete: boolean = false;
  registerThisPlayer: boolean = true;
  clubSelectedPlayers: Array<PlayerInfo> = new Array<PlayerInfo>();

  maxPlayers: number;
  teeSlotNew: boolean = false;
  forBooking: boolean = false;
  fromPartner: boolean = false;
  dataExtras: any = {};
  clubCustomer: boolean = false;

  clubId: number;
  clubMembers: Array<ClubMembership> = new Array<ClubMembership>();
  initTab: string = null;
  noNewPlayer: boolean = false;
  membersOnly: boolean = false;
  partnerInfo: DiscountCompany;
  currentDate: string;
  playerWalletList: Array<any>;
  membershipType: string;
  bookingPlayers: Array<TeeTimeBookingPlayer>;
  noPlayers: boolean = false;
  playerWallet: boolean = false;
  playerAccount: boolean = false;
  filteredClubMembership: Array<ClubMembershipExtended>;
  playerAccountList: Array<any>;
  clubCustomerList: Array<ClubCustomer> = new Array<ClubCustomer>();
  addThisMember: boolean = false;
  _membershipNo: string;
  currencySymbol: string;
  debounceTime: number = 1000;

  @Input () isRouting:any;

  constructor(
    private nav: NavController,
    private navParams: NavParams,
    private modalCtl: ModalController,
    private loadCtl: LoadingController,
    private platform: Platform,
    private keyboard: Keyboard,
    private toastCtl: ToastController,
    private friendService: FriendService,
    private playerService: PlayerService,
    private fb: FormBuilder,
    private alertCtrl: AlertController,
    private playerHomeService: PlayerHomeDataService,
    private flightService: ClubFlightService,
    private loadingCtrl: LoadingController,
    private router: Router,
    private mg2uUtil: mygolfUtils
  ) {
    this.dataExtras = this.router.getCurrentNavigation()?.extras?.state;
    if (!!this.dataExtras) {
      this.openedModal = this.dataExtras?.openedModal;
      this.fromClub = this.dataExtras?.fromClub;
      let exclusion = this.dataExtras?.playersToExclude;
      this.gameInfo = this.dataExtras?.gameInfo;
      this.fromPartner = this.dataExtras?.fromPartner
        ? this.dataExtras?.fromPartner
        : false;
      if (this.fromClub) this.clubId = this.dataExtras?.clubId;
    } else {
      this.openedModal = navParams.get('openedModal');
      this.fromClub = navParams.get('fromClub');
      this.currencySymbol = navParams.get('currencySymbol');
      if (this.fromClub) this.clubId = navParams.get('clubId');
      this.noNewPlayer = navParams.get('noNewPlayer');
      this.membersOnly = navParams.get('membersOnly');
      this.initTab = navParams.get('initTab');
      this.fromPartner = navParams.get('fromPartner');
      this.partnerInfo = navParams.get('partnerInfo');
      this.currentDate = navParams.get('currentDate');
      this.bookingPlayers = navParams.get('bookingPlayers');
      this.membershipType = navParams.get('membershipType');
      this.clubCustomer = navParams.get('clubCustomer');
      this.noPlayers = navParams.get('noPlayers');
      this.playerWallet = navParams.get('playerWallet');
      this.playerAccount = navParams.get('playerAccount');
      let exclusion = navParams.get('playersToExclude');
      if (exclusion) {
        this.playersToExclude.push(...exclusion);
      }
      this.maxPlayers = this.navParams.get('maxPlayers');
      this.teeSlotNew = this.navParams.get('teeSlotNew');
      this.forBooking = this.navParams.get('forBooking');
    }
    if (this.fromClub) {
      this.listMode = 'others';
    } else {
      this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
      this.player$ = this.playerHomeInfo$.pipe(
        map((playerHome: PlayerHomeInfo) => playerHome.player)
      );
      this.player$.pipe().subscribe((player: PlayerInfo) => {
        this.currentPlayerId = player.playerId;
      });
    }
    if (this.initTab) {
      this.listMode = this.initTab;
      if (this.listMode === 'members') this.refreshClubMembersList();
      else if (this.listMode === 'partnerMembers') this.getPartnerMemberships();
      else if (this.listMode === 'playerWallet') this.refreshPlayerWalletList();
    }
    if (this.membersOnly) {
      this.listMode = 'members';
      this.refreshClubMembersList();
    } else if (this.playerWallet) {
      this.listMode = 'playerWallet';
      this.refreshPlayerWalletList();
      this.getBulkMembershipPromise()
        .then((result: any) => {
          if (result) {
            if (result.status === 'success') {
              if (result.clubMembership)
                this.filteredClubMembership = result.clubMembership;
              else this.filteredClubMembership = [];
            } else this.filteredClubMembership = [];
          } else this.filteredClubMembership = [];
        })
        .catch((error) => { });
    } else if (this.playerAccount) {
      this.listMode = 'playerAccount';
      this.refreshPlayerAccountList();
      this.getBulkMembershipPromise()
        .then((result: any) => {
          if (result) {
            if (result.status === 'success') {
              if (result.clubMembership)
                this.filteredClubMembership = result.clubMembership;
              else this.filteredClubMembership = [];
            } else this.filteredClubMembership = [];
          } else this.filteredClubMembership = [];
        })
        .catch((error) => { });
    } else if (this.clubCustomer) {
      this.listMode = 'clubCustomer';
      this.refreshClubCustomerList();
    }

    // this.openedModal = this.navParams.get('openedModal');
    // this.openedModal = navParams.get('openedModal');
    // let exclusion = navParams.get('playersToExclude');
    // this.gameInfo = navParams.get('gameInfo');
    // this.fromClub = navParams.get('fromClub');
    // if (this.fromClub) this.clubId = navParams.get('clubId');

    this.listFriends = {
      totalPages: 0,
      currentPage: 0,
      totalItems: 0,
      totalInPage: 0,
      success: true,
      players: new Array<PlayerInfo>(),
    };
    // if (this.gameInfo && this.gameInfo.availablePlayers && this.gameInfo.availablePlayers.length) {
    //     this.listFriends.players = this.gameInfo.availablePlayers.filter((p: PlayerInfo) => {
    //         let found = this.playersToExclude.filter(pl => {
    //             return pl.player.id === p.playerId;
    //         });
    //         return found.length === 0;
    //     });
    // }

    this.addPlayerForm = this.fb.group({
      playerName: new FormControl('', [
        <any>Validators.required,
        <any>Validators.maxLength(50),
      ]),
      email: new FormControl('', [
        <any>Validators.required,
        <any>Validators.email,
        <any>Validators.maxLength(50),
      ]),
      gender: new FormControl('M'),
      phone: new FormControl('', [
        <any>Validators.required,
        Validators.minLength(7),
        <any>Validators.maxLength(50),
      ]),
    });

    this.playerName = this.addPlayerForm.controls['playerName'];
    this.email = this.addPlayerForm.controls['email'];
    this.gender = this.addPlayerForm.controls['gender'];
    this.phone = this.addPlayerForm.controls['phone'];

    this.playerList = createPlayerList();

    this.clubSelectedPlayers.pop();
  }

  ngOnInit() {
    if (!this.fromClub) {
      if (!this.listFriends.players.length) this._refreshValues();
      else {
        this._filterOnSearch();
        // if(this.listMode === 'member')
        if (this.fromClub) this.refreshClubMembersList();
      }
    }
    this.getDebounceTime().then((debounceTime: number) => {
      this.debounceTime = debounceTime;
    });
    console.log(this.isRouting,'isRouting')
  }
  getDebounceTime() {
    return new Promise((resolve, reject) => {
      let _debounceTime: number = 1000;
      let _appAttributes = this.mg2uUtil.getAppAttribute();
      if (_appAttributes)
        _appAttributes
          .filter((attr) => {
            return attr.page === 'mainApp';
          })
          .map((attr) => {
            _debounceTime = attr.debounceTime;
          });
      resolve(_debounceTime);
    });
  }
  ionViewWillLeave() {
    if (this.platform.is('ios') || this.platform.is('capacitor'))
      this.keyboard.hide();
  }

  onSearchInput() {
    this._filterOnSearch();
  }

  isAPICalling=false;
  async onSearchPlayers(refresher?, infinite?) {
    if(this.isAPICalling) return;
    this.isAPICalling= true;
    if (this.listMode === 'members') {
      this.refreshClubMembersList();
      return;
    } else if (this.listMode === 'playerWallet') {
      this.refreshPlayerWalletList();
      return;
    } else if (this.listMode === 'playerAccount') {
      this.refreshPlayerAccountList();
      return;
    } else if (this.listMode === 'clubCustomer') {
      this.refreshClubCustomerList();
      return;
    } else if (this.listMode === 'partnerMembers') {
      this.getPartnerMemberships();
      return;
    }
    if (!infinite || !this.infiniteComplete) {
      this.playerList = createPlayerList();
      this.players = [];
    }
    if (!this.searchPlayers) {
      this.players = [];
    } else {
      let loader = await this.loadingCtrl.create({
        showBackdrop: false,
        duration: 5000,
        message: 'Searching for player...',
      });
      if (!infinite) {
        this.players = [];
      }

      loader.present().then(() => {
        let _search = this.searchPlayers;
        let _letters = /[0-9]/;

        if (_search.match(_letters) && !infinite) {
          this.flightService
            .getPlayerById(Number(_search))
            .subscribe((response: any) => {
              let _data;
              if (response || (response.status && response.status === 200)) {
                _data = response;
                _data.playerId = _data.id;
                JsonService.deriveFullUrl(_data, 'profile');
                JsonService.deriveFullUrl(_data, 'image');
                if (this.playersToExclude.length > 0) {
                  let _found = this.playersToExclude.find((pe) => {
                    if (pe && pe.player && pe.player.id === _data.id)
                      return false;
                    else {
                      console.debug("get player by id [0] ", this.players, _data)
                      return true
                      // this.players.unshift(_data);
                    }
                  });
                  if(_found) this.players.unshift(_data)
                } else {
                  console.debug("get player by id [1]", this.players, _data)
                  this.players.unshift(_data);
                }
              }
            });
        }

        this.playerService
          .searchPlayers(
            this.searchPlayers,
            true,
            this.playerList.currentPage + 1
          )
          .subscribe(
            (playerList: PlayerList) => {
              loader.dismiss().then(() => {
                if (playerList.totalPages > 0) this.playerList.currentPage++;

                if (playerList && playerList.players) {
                  let _players = playerList.players.filter((p) => {
                    let excluded = this.playersToExclude.find((pe) => {
                      if (pe && pe.player && pe.player.id && p && p.playerId)
                        return pe.player.id === p.playerId;
                      else return false;
                    });
                    let clubSelected = this.clubSelectedPlayers.find((cp) => {
                      if (cp.playerId === p.playerId) return true;
                      else return false;
                    });
                    return !excluded && !clubSelected;
                  });

                  this.playerList = playerList;
                  this.playerList.currentPage = playerList.currentPage;
                  this.playerList.totalPages = playerList.totalInPage;
                  this.playerList.totalItems = playerList.totalItems;
                  this.playerList.players.push(..._players);
                  this.players.push(..._players);
                }
              });
            },
            (error) => {
              loader.dismiss();
            },
            () => {
              if (infinite) {
                infinite.target.complete();
              }

              if(this.isAPICalling) this.isAPICalling = false;
            }
          );
      });
    }
  }

  friendSelected(item: PlayerInfo | any, etc?: any) {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length > 0)
      return false;
    let _amount = 0;
    let _isNewPlayer = item ? false : true;
    if (this.playerWallet) _amount = etc.availableBalance;
    else if (this.playerAccount) _amount = etc.creditLimit + etc.balanceAmount;
    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      playerDetails: this.addPlayerForm.value,
      playerContact: '',
      availableBalance: _amount,
    });
    // if(this.isCovid) {
    //     this._additionalForm(item);
    // } else {
    //     this.viewCtl.dismiss(item);
    // }
  }

  memberSelected(item: PlayerData, member?: ClubMembershipExtended) {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length > 0)
      return false;
    let _isNewPlayer = item ? false : true;

    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      playerDetails: this.addPlayerForm.value,
      playerContact: '',
      membershipDetails: member,
    });
    // if(this.isCovid) {
    //     this._additionalForm(item);
    // } else {
    //     this.viewCtl.dismiss(item);
    // }
  }

  getImage(item: any) {
    // PlayerInfo
    if (item.thumbnail) return item.thumbnail;
    else if (item.photoUrl) return item.photoUrl;
    else if (item.profile) return item.profile;
    else if (item.image) return item.image;
    else
      return 'http://clslet.mygolf2u.com:80/document/contact/David Beckham.8511_thumbnail.jpeg';
  }

  private async _refreshValues() {
    let busy = await this.loadCtl.create({
      message: 'Please wait...',
      duration: 5000,
    });
    busy.present().then(() => {
      this.friendService.searchFriends('', true).subscribe(
        (friendRequests: PlayerList) => {
          busy.dismiss().then(() => {
            this.listFriends.players = friendRequests.players.filter((p) => {
              let found = this.playersToExclude.filter((pl) => {
                if (pl.player) return pl.player.id === p.playerId;
              });
              return found.length === 0;
            });
            // this.gameInfo.
            this.availablePlayers = this.listFriends.players;
            // this._filterOnSearch();
            this.friends = this.listFriends.players;
            // if(this.searchQuery && this.searchQuery.length > 0) {
            //     this.listFriends.players = this.listFriends.players.filter((p: PlayerInfo)=>{
            //         if(p.playerName.toLowerCase().includes(this.searchQuery.toLowerCase()))
            //             return true
            //         if(p.email.toLowerCase().includes(this.searchQuery.toLowerCase()))
            //             return true
            //     })
            //     this.friends = this.listFriends.players
            //     this.availablePlayers = this.listFriends.players;
            // }
          });
        },
        (error) => {
          busy.dismiss().then(() => {
            let msg = MessageDisplayUtil.getErrorMessage(
              error,
              'Error getting friend list'
            );
            MessageDisplayUtil.showErrorToast(
              msg,
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
          });
        }
      );
    });
  }

  private _filterOnSearch() {
    if (!this.searchQuery) this.friends = this.listFriends.players;
    else {
      this.friends = this.listFriends.players.filter((p: PlayerInfo) => {
        let name;
        let firstName;
        let lastName;
        if (!p) return false;
        // || !p.playerName || !p.firstName || !p.lastName
        if (p.playerName) name = p.playerName.toLowerCase();
        if (p.firstName) firstName = p.firstName.toLowerCase();
        if (p.lastName) lastName = p.lastName.toLowerCase();

        if (name && name.indexOf(this.searchQuery.toLowerCase()) >= 0)
          return true;
        else if (
          firstName &&
          firstName.indexOf(this.searchQuery.toLowerCase()) >= 0
        )
          return true;
        else if (
          lastName &&
          lastName.indexOf(this.searchQuery.toLowerCase()) >= 0
        )
          return true;
        else return false;
      });
    }
  }

  async newContact() {
    let newContactModal = await this.modalCtl.create({
      component: NewContactPage,
      componentProps: {
        openedAsDialog: true,
      },
    });
    newContactModal.onDidDismiss().then((data: any) => {
      //Check whether the club info is passed
      if (data) {
        this.playerSelected(null, data);
      }
    });
    newContactModal.present();
  }

  playerSelected(event, item: PlayerInfo) {
    if (this.openedModal) {
      this.modalCtl.dismiss(item);
    }
  }

  close() {
    this.modalCtl.dismiss();
  }

  addMultiPlayers() {
    if (this.clubSelectedPlayers && this.clubSelectedPlayers.length === 0)
      return false;
    // let item = this._newPlayer?this._newPlayer.playerName?this._newPlayer:null:null;
    // let _isNewPlayer = item?false:true;
    this.modalCtl.dismiss({
      item: this.clubSelectedPlayers,
      isCovid: true,
      newPlayer: false,
      // playerDetails: this.addPlayerForm.value,
      playerDetails: {},
      playerContact: '', //playerContact
      multiPlayers: true,
      // registerThisPlayer: this.registerThisPlayer
    });
  }

  addPlayer() {
    if (this.registerThisPlayer) {
      if (
        !this._email ||
        !this._playerName ||
        this._email.length === 0 ||
        this._playerName.length === 0
      ) {
        MessageDisplayUtil.showErrorToast(
          'Please fill-in Player Name and Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      if (!this.emailIsValid(this._email)) {
        MessageDisplayUtil.showErrorToast(
          'Please use valid Email Address',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
      if (this.addThisMember) {
        if (!this._membershipNo || this._membershipNo.length === 0) {
          MessageDisplayUtil.showErrorToast(
            'Please fill-in Club Membership Number',
            this.platform,
            this.toastCtl,
            5000,
            'bottom'
          );
          return false;
        }
      }
    } else if (!this.registerThisPlayer) {
      if (!this._playerName || this._playerName.length === 0) {
        MessageDisplayUtil.showErrorToast(
          'Please fill-in Player Name',
          this.platform,
          this.toastCtl,
          5000,
          'bottom'
        );
        return false;
      }
    }
    let item = this._newPlayer
      ? this._newPlayer.playerName
        ? this._newPlayer
        : null
      : null;
    let _isNewPlayer = item ? false : true;
    this.modalCtl.dismiss({
      item: item,
      isCovid: true,
      newPlayer: _isNewPlayer,
      // playerDetails: this.addPlayerForm.value,
      playerDetails: {
        email: this._email,
        playerName: this._playerName,
        gender: this._gender,
        phone: this._phone,
        membershipNo: this._membershipNo,
      },
      playerContact: '', //playerContact
      registerThisPlayer: this.registerThisPlayer,
      addThisMember: this.addThisMember,
    });
    // if(this.isCovid) {
    //     this._additionalForm();
    // } else {
    //     this.viewCtl.dismiss({
    //         newPlayer: true,
    //         playerDetails: this.addPlayerForm,
    //         // playerContact: playerContact

    //     });
    // }
  }

  addMeself() {
    this.player$.pipe().subscribe((player: PlayerInfo) => {
      this.modalCtl.dismiss({
        item: player,
        isCovid: true,
        newPlayer: false,
        playerDetails: '', //this.addPlayerForm.value,
        playerContact: '', //playerContact
      });
      // if(this.isCovid) {
      //     this._additionalForm(player);
      // } else {
      //     this.viewCtl.dismiss(player);
      // }
      // this.viewCtl.dismiss(player)
    });
  }

  async _additionalForm(item?: PlayerInfo) {
    let _isNewPlayer = item ? false : true;
    // <h3 style="color:red">COVID-19 Important Notice</h3>
    let _message = `<img item-left src="assets/img/booking-item-covid.svg" style="float:left;width: 4em;margin: 0.5em;" />

        <h4 item-right style="color:red;white-space: normal;">MGA recommends that all players should include their
            addresses for contact tracing</h4>`;
    let alert = this.alertCtrl.create({
      header: 'COVID-19 Important Notice',
      // subTitle: 'Selected date is '+ _date,
      message: _message, //'Selected date is ' + '<b>' + _date + '</b>',
      // buttons: ['Close']
      inputs: [
        {
          name: 'playerContact',
          placeholder: 'Enter address',
        },
      ],
      buttons: [
        {
          text: 'Proceed',
          // role: 'cancel',
          handler: (playerContact) => {
            this.modalCtl.dismiss({
              item: item,
              isCovid: true,
              newPlayer: _isNewPlayer,
              playerDetails: this.addPlayerForm.value,
              playerContact: playerContact,
            });
            // this.nav.push(BookingHomePage, {
            //     fromBookNow: true
            // })
            // console.log('Cancel clicked');
          },
        },
      ],
    });
    (await alert).present();

    // let newContactModal = this.modalCtl.create(NewContactPage, {
    //     openedAsDialog: true
    // });
    // newContactModal.onDidDismiss((data: PlayerInfo) => {
    //     //Check whether the club info is passed
    //     if (data) {
    //         this.playerSelected(null, data);
    //     }
    // });
    // newContactModal.present();
  }

  async onKeySearchPlayerByEmail() {
    let _valueChanged = this.email.valueChanges.pipe(
      debounceTime(1500),
      distinctUntilChanged()
    );
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      duration: 5000,
      message: 'Checking for existing player...',
    });

    // if(this.email.valid && _valueChanged) {
    if (this._email && this._email.length > 10) {
      // console.log("email value - debounce ", this.email.value)

      // console.log("email value - debounce value changed", _valueChanged)

      // _valueChanged.subscribe(()=>{
      let _email = this._email; //this.email.value;

      // console.log("email value - debounce subscribe ", this.email.value, _email)
      this.flightService.getPlayerByEmail(_email).subscribe((data: any) => {
        loader.onDidDismiss().then((data: any) => {
          if (data.length > 0 && data[0]) {
            let _data = data[0];
            // this.addPlayerForm['playerName']= data&&data.playerName?data.playerName:data.firstName+' '+data.lastName;
            // this.addPlayerForm['gender'] = data&&data.gender?data.gender:'M';
            // this.addPlayerForm['phone'] = data.address&&data.address.phone1?data.address.phone1:null;
            this._playerName =
              _data && _data.playerName ? _data.playerName : '';
            this._gender = _data && _data.gender ? _data.gender : 'M';
            this._phone =
              _data.addressInfo && _data.addressInfo.phone1
                ? _data.addressInfo.phone1
                : null;
            this._newPlayer = _data;

            // let msg = MessageDisplayUtil.getErrorMessage('Player Found', "Player found");
            MessageDisplayUtil.showErrorToast(
              'Player Found',
              this.platform,
              this.toastCtl,
              5000,
              'bottom'
            );
          } else this._newPlayer = createPlayerInfo();
        });
      });
      // })
    }
    // if(this.email.valid) {
    //     console.log("email value ", this.email.value)
    // this.flightService.getPlayerByEmail(this.email.value)
    // .subscribe((data)=>{
    //     console.log("data")
    // })
    // }
  }

  doInfinite(infinite: any) {
    this.infiniteComplete = this.isMore();
    if (this.isMore()) {
      this.onSearchPlayers(null, infinite);
    } else {

      infinite.target.complete();
      // infinite.enable(false);
    }
  }

  public isMore() {
    return (
      this.playerList.totalPages > 0 &&
      this.playerList.currentPage < this.playerList.totalPages
    );
  }

  // onSearchPlayerByEmail() {
  //     if(this.email.valid) {
  //         this.flightService.getPlayerByEmail(this.email.value)
  //         .subscribe((data)=> {
  //             console.log("after add player data")
  //         })
  //     }
  // }

  // checkAddMe() {
  //     let _hasMe: boolean = false;
  //     console.log("check add me : ", this.playersToExclude, this.currentPlayerId)
  //     // this.playersToExclude.filter((tbp: TeeTimeBookingPlayer)=>{
  //     //    if(this.currentPlayerId && tbp.player.id === this.currentPlayerId) _hasMe = true
  //     //    else _hasMe = false
  //     // })

  //     console.log("check add me : ", _hasMe);
  //     return _hasMe;
  // }

  onAddMulti(player: any) {
    console.debug("selecting ", this.listMode, ' - ', player)
    if (this.clubSelectedPlayers.length >= this.maxPlayers) return false;
    if (this.listMode === 'others' && player) {
      this.clubSelectedPlayers.push(player);
      this.players = this.players.filter((p: PlayerInfo) => {
        return p.playerId !== player.playerId;
      });
    } else if (this.listMode === 'partnerMembers' && player) {
      this.clubSelectedPlayers.push(player);
      this.programMembers = this.programMembers.filter(
        (pm: PlayerDiscountProgram) => {
          return pm.player.id !== player.id;
        }
      );
    } else if (this.listMode === 'members' && player) {
      this.clubSelectedPlayers.push(player);
      this.clubMembers = this.clubMembers.filter((p: ClubMembership) => {
        return p.player.id !== player.id;
      });
    }
    // this.addMultiPlayers();
  }

  getClubSelectedPlayers() {
    let _playersList = '';
    // this.clubSelectedPlayers.forEach((p: PlayerInfo, idx: number) => {
    //   _playersList += p.playerName + ', ';
    // });
    _playersList = this.clubSelectedPlayers.map((p: PlayerInfo) =>{ return p.playerName}).join(',');
    return _playersList; //.slice(0,-1);// .substring(0,_playersList.length-1);
  }

  clearClubSelectedPlayers() {
    this.clubSelectedPlayers.pop();
    this.onSearchPlayers();
  }

  emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  refreshClubMembersList(search?: string) {
    let _clubId = this.clubId;
    let _activeOnly = true;
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      activeOnly: _activeOnly,
      search: _search,
      membershipTypes: _membershipTypes,
      //   status: _status,
    };
    this.flightService
      .getClubMembersList(_clubId, _params)
      .subscribe((data: Array<ClubMembership>) => {
        if (data && data.length > 0)
          this.clubMembers = data.filter((cm: ClubMembership) => {
            let _exclude;
            this.playersToExclude.filter((bp) => {
              if (bp.player.id === cm.player.id) _exclude = true;
            });
            return !_exclude;
          });
      });
  }

  // onSearchById() {
  //   let _search = this.searchPlayers;
  //   let _letters = /[^0-9]/;
  //   //  /^[a-zA-Z]+$/;
  //   if (_search.match(_letters)) {
  //     // if(typeof this.searchPlayers === 'string') {
  //     let msg = 'Please enter valid mg2u ID';
  //     MessageDisplayUtil.showErrorToast(
  //       msg,
  //       this.platform,
  //       this.toastCtl,
  //       5000,
  //       'bottom'
  //     );
  //     return false;
  //   }

  //   this.flightService
  //     .getPlayerById(Number(_search))
  //     .subscribe((response: any) => {
  //       let _data;
  //       if (response && response.status === 200) {
  //         _data = response.json();
  //         _data.playerId = _data.id;
  //         this.players.push(_data);
  //       }
  //     });
  // }
  refreshMode: boolean = false;
  programMembers: any;
  programMembershipPage: any;
  totalInPage: any;
  totalItems: any;
  totalPages: any;
  currentPage: any;
  uniqueMembers: any;
  async getPartnerMemberships(infinite?) {
    let loader = await this.loadingCtrl.create({
      showBackdrop: false,
      message: 'Getting members...',
    });

    // let _params = {}
    this.refreshMode = true;

    if (!infinite) {
      this.programMembers = [];
      this.programMembershipPage = null;
      this.totalInPage = 0;
      this.totalItems = 0;
      this.totalPages = 0;
      this.currentPage = 0;
      this.uniqueMembers = [];
    }
    let _partnerId = this.partnerInfo.id;
    let _params = {
      // validUntil: this.currentDate,
      // validFrom: moment(this.currentDate).subtract(1,'y').format("YYYY-MM-DD"),
      validOn: this.currentDate, //moment().format("YYYY-MM-DD"),
      search: this.searchPlayers,
      pageSize: 100,
    };
    this.flightService.listAllPartnerMemberships(_partnerId, _params).subscribe(
      (data) => {
        if (data && data.items && data.items.length > 0) {
          this.programMembershipPage = data;
          this.totalInPage = data.totalInPage;
          this.currentPage = data.currentPage;
          this.totalItems = data.totalItems;
          this.totalPages = data.totalPages;
          this.currentPage = data.currentPage;
          this.programMembers.push(...data.items);

          setTimeout(() => {
            if (this.programMembers && this.programMembers.length > 0) {
              // console.debug("show membership records : ", this.showMembershipRecords);
              console.debug('show unique members : ', this.programMembers);
              let _uniqMembers = [];
              this.programMembers.forEach((member: PlayerDiscountProgram) => {
                console.debug('show each members : ', member);
                _uniqMembers.push(member.player);
              });
              console.debug('show unique members [0] : ', _uniqMembers);
              console.debug(
                'show unique members [1] : ',
                this.getUnique(_uniqMembers, 'id')
              );
              this.uniqueMembers.push(...this.getUnique(_uniqMembers, 'id'));
            }
          }, 500);
        }
        if (loader) loader.dismiss();
        // this.refreshMode = false;
      },
      (error) => {
        // this.refreshMode = false;
        if (loader) loader.dismiss();
      },
      () => {
        this.refreshMode = false;
        if (infinite) {
          if (infinite.complete) infinite.complete();
          if (this.isMore()) {
            infinite.enable(true);
          } else infinite.enable(false);
        }
      }
    );
  }
  getUnique(arr, comp) {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }
  refreshPlayerWalletList(search?: string) {
    let _clubId = this.clubId;
    let _activeInactive = 'A';
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _pageSize = 1000;
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      activeOrInactive: _activeInactive,
      search: _search,
      membershipTypes: _membershipTypes,
      //   status: _status,
    };
    this.flightService
      .getClubWalletBalance(_clubId, _params)
      .subscribe((data: PlayerClubWalletBalancePage) => {
        if (data && data.items && data.items.length > 0) {
          this.playerWalletList = data.items.sort((a, b) => {
            if (
              a.player.playerName.toLowerCase() <
              b.player.playerName.toLowerCase()
            )
              return -1;
            else if (
              a.player.playerName.toLowerCase() >
              b.player.playerName.toLowerCase()
            )
              return 1;
            else return 0;
          });

          this.playerWalletList = this.playerWalletList.filter((item) => {
            return item.availableBalance > 0;
          });
          if (this.bookingPlayers && this.bookingPlayers.length > 0)
            if (this.playerWalletList && this.playerWalletList.length > 0)
              this.bookingPlayers.forEach((bp: TeeTimeBookingPlayer) => {
                this.playerWalletList = this.playerWalletList.filter((item) => {
                  if (bp.player)
                    return (
                      item.player &&
                      bp.player &&
                      item.player.id !== bp.player.id
                    );
                  else return true;
                });
              });
        }
      });
  }
  isBookingAgent() {
    return this.mg2uUtil.getUserType() === 'booking_agent';
  }
  isPartnerDiscount() {
    if (!this.partnerInfo) return false;
    let _isDiscount = this.partnerInfo.partnerServices.filter((s) => {
      return s === 'DISCOUNT';
    });
    return _isDiscount && _isDiscount.length > 0;
  }
  getBulkMembershipPromise() {
    // console.debug("get membershipnumber promise : ", playerId)

    let _clubMembership: Array<ClubMembershipExtended> = null;
    return new Promise((resolve, reject) => {
      if (
        this.listMode !== 'playerAccount' &&
        this.listMode !== 'playerWallet'
      ) {
        reject({
          status: 'failed',
          message: 'not account or wallet',
        });
      }
      let _playerIds = [];
      if (
        this.listMode === 'playerAccount' &&
        this.playerAccountList &&
        this.playerAccountList.length > 0
      ) {
        _playerIds = this.playerAccountList
          .filter((acc: PlayerClubAccount) => {
            return acc && acc.player;
          })
          .map((acc: PlayerClubAccount) => {
            return acc.player.id;
          });
      } else if (
        this.listMode === 'playerWallet' &&
        this.playerWalletList &&
        this.playerWalletList.length > 0
      ) {
        _playerIds = this.playerWalletList
          .filter((acc: PlayerClubWalletBalance) => {
            return acc && acc.player;
          })
          .map((acc: PlayerClubWalletBalance) => {
            return acc.player.id;
          });
      } else if (this.listMode === 'member') {
        this.clubMembers.forEach((cm: ClubMembershipExtended) => {
          _playerIds.push(cm.player.id);
        });
      }

      let _clubId = this.clubId;
      let _params = {
        playerId: _playerIds,
        pageSize: 1000,
      };
      this.flightService.getFilteredClubMemberships(_clubId, _params).subscribe(
        async (data: any) => {
          // membershipList: Array<ClubMembership>
          // console.debug("club membership list : [1]", this.bookingSlot.clubData)
          if (data) {
            resolve({
              status: 'success',
              message: 'has membership',
              clubMembership: data.items,
            });
          } else {
            reject({
              status: 'failed',
              message: 'no club membership',
              clubMembership: null,
            });
          }
        },
        (error) => {
          reject({
            status: 'failed',
            message: 'no club membership',
            clubMembership: null,
          });
        },
        () => { }
      );
    });
  }
  refreshClubCustomerList(search?: string) {
    let _clubId = this.clubId;
    let _search = search ? search : this.searchPlayers;
    this.clubCustomerList = [];
    let _params = {
      search: _search,
      //   status: _status,
    };
    this.flightService
      .listClubCustomers(_clubId, _params)
      .subscribe((data: Array<ClubCustomer>) => {
        //console.log(`club members : `, data)
        if (data && data.length > 0) this.clubCustomerList = data;
      });
  }
  refreshPlayerAccountList(search?: string) {
    let _clubId = this.clubId;
    let _activeInactive = 'A';
    let _search = search ? search : this.searchPlayers;
    this.clubMembers = [];
    let _pageSize = 1000;
    let _pageNo = 1;
    let _status = null;
    let _membershipTypes = [];
    if (this.membershipType && this.membershipType.length > 0)
      _membershipTypes.push(this.membershipType);
    let _params = {
      withCreditLimit: 'Y', // Y, N, (B)oth
      search: _search,
      pageSize: _pageSize,
      pageNo: _pageNo,
      //   status: _status,
    };
    console.debug('refresh club accounts : ', _params);
    this.flightService
      .getClubAccountsList(_clubId, _params)
      .subscribe((data: PlayerClubWalletBalancePage) => {
        //console.log(`club wallet balance: `, data)
        if (data && data.items && data.items.length > 0) {
          this.playerAccountList = data.items.sort((a, b) => {
            if (
              a.player.playerName.toLowerCase() <
              b.player.playerName.toLowerCase()
            )
              return -1;
            else if (
              a.player.playerName.toLowerCase() >
              b.player.playerName.toLowerCase()
            )
              return 1;
            else return 0;
          });

          this.playerAccountList = this.playerAccountList.filter((item) => {
            return item.creditLimit + item.effectiveBalance > 0;
          });

          console.debug(
            'player account list : ',
            this.bookingPlayers,
            this.playerAccountList
          );

          // if(this.bookingPlayers.length > 0)
          if (this.playerAccountList && this.playerAccountList.length > 0)
            if (this.bookingPlayers && this.bookingPlayers.length > 0)
              this.bookingPlayers.forEach((bp: TeeTimeBookingPlayer) => {
                if (bp && bp.player)
                  this.playerAccountList = this.playerAccountList.filter(
                    (item) => {
                      return (
                        item.player &&
                        bp.player &&
                        item.player.id !== bp.player.id
                      );
                    }
                  );
              });
          console.debug(
            'player account list : ',
            this.bookingPlayers,
            this.playerAccountList
          );
        }
      });
  }

  clubCustomerSelected(customer: ClubCustomer) {
    if (!customer) return;
    let _isNewPlayer = false;

    this.modalCtl.dismiss({
      item: customer,
      isCovid: true,
      newPlayer: _isNewPlayer,
      playerDetails: this.addPlayerForm.value,
      playerContact: '',
    });
  }
  getPlayerMembership(playerId: number, attribute?: string) {
    if (!playerId) return;
    let _membershipNumber: string = '';
    let _membershipTypeName: string = '';

    // console.debug("get player membership : ", playerId, this.filteredClubMembership)
    if (this.filteredClubMembership)
      this.filteredClubMembership
        .filter((cm) => {
          return cm && cm.player && cm.player.id === playerId;
        })
        .map((cm) => {
          _membershipNumber = '(' + cm.membershipNo + ')';
          _membershipTypeName = cm.membershipType.typeName;
        });
    if (attribute === 'typeName') return _membershipTypeName;
    else return _membershipNumber;
  }
  getPlayerWalletDetails(item: any, attribute: string) {
    switch (attribute) {
      case 'walletBalance':
        let _amount =
          this.currencySymbol +
          ' ' +
          this.mg2uUtil.numberWithCommas(item.availableBalance);
        return _amount;
      default:
        return;
    }
  }
  getPlayerAccountDetails(item: any, attribute: string) {
    switch (attribute) {
      case 'accountBalance':
        let _total = item.creditLimit + item.effectiveBalance;
        let _amount =
          this.currencySymbol + ' ' + this.mg2uUtil.numberWithCommas(_total);
        if (_total < 0) return "<span style='color:red'>" + _amount + '</span>';
        else return _amount;
      default:
        return;
    }
  }
}
